import { ReactNode, useContext } from "react";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { OrganizationContext } from "hhn-commons";
import {
  OrgCrumb,
  WorkspaceRoot,
  WsBody,
  WsContent,
  WsHeader,
} from "./WorkspaceLayout.style";

type WorkspaceLayoutProps = {
  // Trail shown AFTER the org name, e.g. ["Export Chat"] or ["More", "EMR", "Setup"].
  path: string[];
  // Returns to Messages (ModalManager passes closeModal, which clears ?modal).
  onClose: () => void;
  // Optional left sub-nav column (only "More" uses one today).
  sideNav?: ReactNode;
  children: ReactNode;
};

export default function WorkspaceLayout({
  path,
  onClose,
  sideNav,
  children,
}: WorkspaceLayoutProps) {
  const { selectedOrgUser } = useContext(OrganizationContext);
  const orgName =
    selectedOrgUser?.getOrganization().organizationName || "Organization";

  return (
    <WorkspaceRoot>
      <WsHeader>
        <OrgCrumb onClick={onClose} title="Back to Messages">
          {orgName}
        </OrgCrumb>
        {path.map(part => (
          <span key={part} style={{ display: "flex", gap: 8 }}>
            <span>&rsaquo;</span>
            <span>{part}</span>
          </span>
        ))}
        <IconButton
          size="small"
          sx={{ marginLeft: "auto" }}
          onClick={onClose}
          data-testid="workspace-close"
          title="Back to Messages"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </WsHeader>
      <WsBody>
        {sideNav}
        <WsContent>{children}</WsContent>
      </WsBody>
    </WorkspaceRoot>
  );
}
